import { render, staticRenderFns } from "./newTeachingMaterialAdd.vue?vue&type=template&id=1f65210c&scoped=true"
import script from "./newTeachingMaterialAdd.vue?vue&type=script&lang=js"
export * from "./newTeachingMaterialAdd.vue?vue&type=script&lang=js"
import style0 from "./newTeachingMaterialAdd.vue?vue&type=style&index=0&id=1f65210c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f65210c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f65210c')) {
      api.createRecord('1f65210c', component.options)
    } else {
      api.reload('1f65210c', component.options)
    }
    module.hot.accept("./newTeachingMaterialAdd.vue?vue&type=template&id=1f65210c&scoped=true", function () {
      api.rerender('1f65210c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/newTeachingMaterial/newTeachingMaterialAdd.vue"
export default component.exports